import PropTypes from "prop-types";
import data from "bootstrap/js/src/dom/data";
import {FormSelect} from "react-bootstrap";
import {useEffect} from "react";

export function FormSelectList(props) {
    const {onChange, dataList, value, defaultValueText} = props;
    return <>
        <FormSelect value={value ? value : ''} onChange={onChange}>
            {[
                <option key={1000} value={defaultValueText}>{defaultValueText}</option>,
                dataList?.map(
                    (d,index) => <option key={index} value={d}>{d}</option>
                )
            ]}
        </FormSelect>
    </>
}

FormSelectList.propTypes =
    {
        onChange: PropTypes.func,
        defaultValueText: PropTypes.string,
        dataList: PropTypes.array,
        value: PropTypes.any
    }